import React from 'react'
import AssessmentTable from './AssessmentTable'

function Upcoming({globalReset,filterIntake,filterLearningMethod,filterSchool,filterLecturer}) {
  return (
    <AssessmentTable globalReset={globalReset} filterIntake={filterIntake} filterLearningMethod={filterLearningMethod} filterSchool={filterSchool} filterLecturer={filterLecturer}/>
  )
}

export default Upcoming